export default __webpack_public_path__ + "98af3bb8624d105e459dff13d1d2beda.png";